export default __webpack_public_path__ + "static/media/YourHealthYourWayScreenshot2022-08-19092953.b902f0b0.jpg";